import react, { useEffect, useRef, useState } from "react";
import "../styles/PatientReportFileTemplateCreate.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  postAppointment,
} from "../Redux/Thunk/Actions";
import { prescriptionType, patientid } from "../Redux/Slice/rootSlice";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../assets/images/ascas.svg";
import Headers from "./Header/Headers";

function CbgReportTemplate(props) {
  const selectedTab = useSelector((state) => state.counter.prescriptionType);
  const patientId = useSelector((state) => state.counter.patientid);
  const [show, setshow] = useState(false);
  const [NumToWords, setNumToWords] = useState(0);
  const Content = useRef();
  const [cbgReportTable, setCbgReportTable] = useState(1);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
    });
  const [valueChange, setvalueChange] = useState({
    gender1: "Male",
    gender2: "Male",
    bloodGroup1: "A+",
    bloodGroup2: "A+",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleChange = (e) => {
    setvalueChange({ ...valueChange, [e.target.name]: e.target.value });
    if (e.target.name === "nextappointment") {
      const dateTime = e.target.value.split("T");
      setAppointmentData({
      ...appointmentData,
      date: dateTime[0],
      time: dateTime[1],
      p_uhid: props.patientsData.p_uhid,
      name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
      status: "Not Visited",
      notes: "Booking Visit",
      patient_id: patientId,
      });
      }
      
  };
  const handletest = () => {
    setshow(true);
    props.loaderchange("true");
    setTimeout(() => {
      const CreateThunk = async () => {
        let htmlPayload;
        htmlPayload = document.getElementById(
          "prescriptionReportWrap"
        ).innerHTML;
        console.log(htmlPayload, "liki");
        const payload = {
          patient_id: patientId,
          template_type: selectedTab,
          prescription_template: htmlPayload,
        };
        props.loaderchange(true);
        const patentReport = postPatientReport({
          type: "1",
          payload: payload,
        });
        const createNewAppointment = async () => {
          console.log(appointmentData);
          await dispatch(postAppointment(appointmentData));
          };
          createNewAppointment();
        const response = await dispatch(patentReport);
        if (response?.payload?.status?.code === 200) {
          props.loaderchange(false);
          navigate("/PatientView");
          Swal.fire({
            title: "Successful.",
            text: "Report added successful.",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          props.loaderchange("true");
        } else {
          props.loaderchange("false");
          props.popupalert("true");
          props.popuptext("Network went wrong, Please try after some time.");
          // props.popuptext(response?.status?.message);
          setTimeout(() => {
            props.popupalert("false");
          }, 2000);
        }
      };
      CreateThunk();
    }, 2000);
    props.loaderchange("false")

  };

  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value, options = {}) => {
    const { style = { border: "1px solid black", textAlign: "center" } } =
      options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const {
      style = { border: "1px solid black", textAlign: "center" },
      colspans = 1,
    } = options;
    return (
      <th colSpan={colspans} style={style}>
        {value}
      </th>
    );
  };
  return (
    <>
      <div
        style={{ backgroundColor: "white" }}
        className="patientreport"
        id="reportcreate"
      >
        {/* Billing Heading */}
        <>
          <div style={{ width: "100%" }}>
            <img
              className="header_image"
              // src={"https://s3.amazonaws.com/likodi.com/ascslogo.png"}
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: "100%",
                margin: "0 auto",
              }}
            ></img>
          </div>
        </>
        <div
          style={{
            maxWidth: "97%",
            margin: "0 auto",
            // border: "1px solid",
            // borderTop: "none",
            paddingTop: "10px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={props.patientsData.p_uhid}
                  onChange={(e) => handleChange(e)}
                  name="patientId"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.p_uhid}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name="patientName"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={valueChange.gender1}
                  name="gender"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.gender}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={props.patientsData.age}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{props.patientsData.age}
              </span>
            </div>
          </div>
          <table
            style={{
              borderSpacing: "0",
              marginBottom: "30px",
              width: "98%",
            }}
          >
            <thead style={{ border: "1px solid", padding: "0px" }}>
              <tr
                style={{
                  border: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <th style={{ border: "1px solid", padding: "10px" }}>DATE</th>
                <th style={{ border: "1px solid", padding: "10px" }}>
                  FASTING
                </th>
                <th style={{ border: "1px solid", padding: "10px" }}>
                  AFTER BREAKFAST
                </th>
                <th style={{ border: "1px solid", padding: "10px" }}>
                  AFTER DINNER
                </th>
                <th style={{ border: "1px solid", padding: "10px" }}>BP</th>
                <th style={{ border: "1px solid", padding: "10px" }}>
                  MEDICATION
                </th>
              </tr>
            </thead>
            <tbody>
              {[...Array(cbgReportTable)].map((_, i) => {
                return (
                  <tr
                    key={i}
                    style={{
                      borderBottom: "1px solid",
                      borderSpacing: "0px",
                      borderCollapse: "collapse",
                    }}
                  >
                    <td style={{ border: "1px solid" }}>
                      <input
                        name={`date_${i}`}
                        onChange={handleChange}
                        type="date"
                      />
                    </td>
                    <td style={{ border: "1px solid" }}>
                      <input
                        name={`fasting_${i}`}
                        onChange={handleChange}
                        type="text"
                      />
                    </td>
                    <td style={{ border: "1px solid" }}>
                      <input
                        name={`afterBreakFast_${i}`}
                        onChange={handleChange}
                        type="text"
                      />
                    </td>
                    <td style={{ border: "1px solid" }}>
                      <input
                        name={`afterDinner_${i}`}
                        onChange={handleChange}
                        type="text"
                      />
                    </td>
                    <td style={{ border: "1px solid" }}>
                      <input
                        name={`bp_${i}`}
                        onChange={handleChange}
                        type="text"
                      />
                    </td>
                    <td style={{ border: "1px solid" }}>
                      <input
                        name={`medication_${i}`}
                        onChange={handleChange}
                        type="text"
                      />
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td
                  className="AddRemoveRowBtns"
                  colSpan="6"
                  border="none"
                  style={{ textAlign: "center" }}
                >
                  <button
                    class="btn btn-info"
                    style={{ color: "white", marginRight: "5px" }}
                    onClick={() => setCbgReportTable(cbgReportTable + 1)}
                  >
                    Add
                  </button>
                  <button
                    class="btn btn-info"
                    style={{ color: "white" }}
                    onClick={() =>
                      setCbgReportTable(
                        cbgReportTable == 1 ? 1 : cbgReportTable - 1
                      )
                    }
                  >
                    Remove
                  </button>
                </td>
              </tr>
              {/* <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
                <td style={{ border: "1px solid", padding: "25px" }}></td>
              </tr> */}
            </tbody>
          </table>
        </div>
      </div>


      <p style={{fontWeight:"600"}}>
NEXT APPOINTMENT -{" "}
<input
name="nextappointment"
onChange={handleChange}
type="datetime-local"
// type="date"
/>
</p>
      <>

        <div
          style={{
            // display: "grid",
            // gridTemplateColumns: "1fr 3fr",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
            //   gap: "16px",
            overflowX: "hidden",
            maxWidth: "97%",
            margin: "0 auto",
            border: "1px solid",
          }}
          className="report-template-wrap1"
        >
          <div className="" style={{ width: "100%" }} id="patientInfo1">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                // gap: "10px",
                borderRadius: "6px",
                padding: "16px 8px 16px 8px",
                height: "100%",
              }}
            >
              <h2>INSTRUCTIONS:</h2>
              <p style={{ fontSize: "16px" }}>
                1. To do CBG charting every weekly or two weekly once as per
                consultant advise.
              </p>
              <p>
                2. To inform DMO (73050 44413)/ fix teleconsultation with
                Diabetologist if Fasting value is more than 90mg/dl (or) if 1hr
                after food is more than 140mg/dl (or) if 2 hr after food is more
                than 120mg/dl.
              </p>
              <p>3. Can get personalised Diet chart from Dietician.</p>
              <p>4. Avoid low sugars. Do not miss meals.</p>
            </div>
          </div>
        </div>
      </>

      <div className="Footer">
        <button
          onClick={(event) => {
            handletest(event);
          }}
          className="Button_Create"
        >
          Generate
        </button>
      </div>
      <div id="prescriptionReport">
        <div id="prescriptionReportWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          <div>
            <table style={{ width: "100%", marginBottom: "30px" }}>
              <thead>
                <tr>
                  {[
                    "DATE",
                    "FASTING",
                    "AFTER BREAKFAST",
                    "AFTER DINNER",
                    "BP",
                    "MEDICATION",
                  ].map((ele) => renderTableTH(ele))}
                </tr>
              </thead>
              <tbody>
                {[...Array(cbgReportTable)].map((_, i) => {
                  const val = [
                    "date_",
                    "fasting_",
                    "afterBreakFast_",
                    "afterDinner_",
                    "bp_",
                    "medication_",
                  ];
                  return (
                    <tr key={i}>
                      {val.map((ele, ind) =>
                        renderTableTD(valueChange[`${ele + i}`])
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
              padding: "0 15px",
            }}
          >
            <div style={{ display: "flex", marginTop: "10px" }}>
              <h5 style={{ fontWeight: 600, marginRight: "5px" }}>
                INVESTIGATION :
              </h5>
            </div>
            <p>
              1. To do CBG charting every weekly or two weekly once as per
              consultant advise.
            </p>
            <p>
              2. To inform DMO (73050 44413)/ fix teleconsultation with
              Diabetologist if Fasting value is more than 90mg/dl (or) if 1hr
              after food is more than 140mg/dl (or) if 2 hr after food is more
              than 120mg/dl.
            </p>
            <p>3. Can get personalised Diet chart from Dietician.</p>
            <p>4. Avoid low sugars. Do not miss meals.</p>
          </div>
          <div style={{ marginTop: "10px" }}>
{renderReportfield("Next Appointment : ",appointmentData.date?.split("-").reverse().join("-"))}
</div>
          <p class="Dani"></p>
        </div>
      </div>
    </>
  );
}

export default CbgReportTemplate;
